import { type BenefitDetailAmounts, type PlanLevel } from 'schemas';

export const FAMILY_PLAN_LEVEL: PlanLevel = 'Family';
export const INDIVIDUAL_PLAN_LEVEL: PlanLevel = 'Individual';
export const OOP_AMOUNT_KEY: keyof BenefitDetailAmounts = 'outOfPocket';
export const DEDUCTIBLE_AMOUNT_KEY: keyof BenefitDetailAmounts = 'deductibles';
export const VALID_AMOUNT_KEYS: (keyof BenefitDetailAmounts)[] = [
  OOP_AMOUNT_KEY,
  DEDUCTIBLE_AMOUNT_KEY,
];
export const ACTIVE_COVERAGE_STATUS: string = 'Active Coverage';
